import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material';
import { useDocumentTypeList } from '../../fetch/fetchClassificationItems';
import { useIsInViewport } from '../../hooks';
import Spinner from '../spinner/Spinner';

export default function DocumentListTable({ documents, serialMatch, onLoadMore, loadMoreVisible,
    notLoading, requestTotalRecords, serialNoteHeight }) {
    const theme = useTheme();
    const scrollViewerTop = theme.appBar.height + theme.subBar.height
    const { documentTypes } = useDocumentTypeList();

    const {
        families
    } = useSelector((state) => state.libraryFilters);

    const loadMoreRef = useRef(null);
    const [isInViewport1, _intersectionRatio] = useIsInViewport(loadMoreRef);
    if (isInViewport1 && notLoading && documents.length < requestTotalRecords) {
        setTimeout(() => onLoadMore(), 250);
    }

    const isFamilyMatch = (!!families && families.length > 0) || serialMatch;

    const tableContainerHeight = serialNoteHeight > 0 ?
        `calc(100vh - ${scrollViewerTop}px - ${serialNoteHeight}px - 2.5em)` :
        `calc(100vh - ${scrollViewerTop}px - 3.5em)`;
    return (
        <Grid container columns={{ xs: 1 }} spacing={2}>
            <Paper
                sx={{
                    p: 1.5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    width: 'calc(100% - 1em)',
                    marginLeft: '1em',
                    marginTop: '.5em',
                    marginBottom: '1em',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    position: 'relative'
                }}
            >
                <TableContainer style={{ maxHeight: tableContainerHeight }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>Part Number</TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>Type</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {requestTotalRecords == 0 && notLoading ? (
                                <TableRow>
                                    <TableCell colSpan={3} align="center">
                                        <Typography variant="h6">
                                            No Results
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ) : null}
                            {documents.map((document, index) => {
                                return (
                                    <React.Fragment key={document.partNumber}>
                                        {isFamilyMatch && index === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={3}>
                                                    <b>{getSimplifiedDocumentType(document.documentTypeId, documentTypes)}</b>
                                                </TableCell>
                                            </TableRow>
                                        ) : null}
                                        {isFamilyMatch && index > 0 && !isGroupMatching(documents[index - 1].documentTypeId, document.documentTypeId) ? (
                                            <TableRow>
                                                <TableCell colSpan={3}>
                                                    <br />
                                                    <b>{getSimplifiedDocumentType(document.documentTypeId, documentTypes)}</b>
                                                </TableCell>
                                            </TableRow>
                                        ) : null}
                                        <TableRow>
                                            <TableCell><a href={document.documentTypeId != 7 ? `/literature/view/${document.partNumber}` : `/literature/video/${document.partNumber}`}>{document.partNumber}</a></TableCell>
                                            <TableCell>{document.title}</TableCell>
                                            <TableCell>{documentTypes.filter(it => it.id == document.documentTypeId)[0]?.name}</TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                );
                            })}
                            <TableRow style={{ display: loadMoreVisible ? null : 'none' }} ref={loadMoreRef}>
                                <TableCell colSpan={3} style={{ textAlign: 'center' }}>
                                    {notLoading ? (
                                        <Button
                                            onClick={() => onLoadMore()}
                                        >
                                            Load Next
                                        </Button>
                                    ) : (
                                        <Spinner width={40} />
                                    )}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Grid>
    );
}

const getSimplifiedDocumentType = (documentType, documentTypes) => {
    if (boilDownTypeId(documentType) == 1) {
        return "Manuals";
    }

    if (boilDownTypeId(documentType) == 2) {
        return "Bulletins/Advisories";
    }

    return documentTypes.filter(it => it.id == boilDownTypeId(documentType))[0]?.name;
}

const boilDownTypeId = (documentType) => {
    if (documentType == 5 || documentType == 6) {
        documentType = 1;
    }
    if (documentType == 9 || documentType == 10) {
        documentType = 2;
    }

    return documentType;
}

const isGroupMatching = (documentType1, documentType2) => {
    return boilDownTypeId(documentType1) == boilDownTypeId(documentType2);
}